import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from '@app/_services/request.service';
import { authorityIds, operations, subAuthorities } from '@app/enums';

@Injectable({ providedIn: 'root' })
export class PortfolioApiService {
  constructor(private REQ: RequestService) {}

  getPortfolioList(): Observable<any> {
    const qry = {
      params: {},
      user_data: {
        authority: authorityIds.PORTFOLIO,
        sub_authority: subAuthorities.PORTFOLIO.LIST,
        operation: operations.LIST,
        data: 'NA',
      },
    };
    return this.REQ.get('portfolio/list', { query: JSON.stringify(qry) });
  }
}
